import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M9.5 2c4.687 0 8.5 3.813 8.5 8.5S14.187 19 9.5 19C4.813 19 1 15.186 1 10.5S4.814 2 9.5 2zm0-1C4.253 1 .001 5.253 0 10.5c.001 5.246 4.253 9.499 9.5 9.5 5.247-.001 9.5-4.254 9.5-9.5S14.747 1 9.5 1z',
    'M10 12.051V8H9v4.051c-1.14.232-2 1.242-2 2.449C7 15.879 8.121 17 9.5 17s2.5-1.121 2.5-2.5c0-1.207-.86-2.217-2-2.449zM9.5 16c-.828 0-1.5-.672-1.5-1.5S8.672 13 9.5 13s1.5.672 1.5 1.5-.672 1.5-1.5 1.5zM6 5h1v1H6V5zM12 5h1v1h-1V5zM9 4h1v1H9V4zM4 7h1v1H4V7zM14 7h1v1h-1V7z',
  ],
  height: 20,
  width: 20,
});
